export default {
    created: "Tag-ul WhatsApp a fost creat cu succes.",
    updated: "Tag-ul WhatsApp a fost actualizat cu succes.",
    deleted: "Tag-ul WhatsApp a fost sters cu succes.",
    restored: "Tag-ul WhatsApp a fost restaurat cu succes.",
}
